<template>
  <div>
    <!-- 설정:: 링크 -->
    <div v-if="mode === 'link'" class="setLink">
      <div v-if="Object.keys(link).length === 0"></div>
      <div v-else>
        <SetLink :link="link" />
      </div>
    </div>
    <!-- 설정:: SNS -->
    <div v-else-if="mode === 'sns'">
      <ul>
        <li v-for="(sns, index) in snsList" :key="index" class="mb15">
          <span class="checkbox f_medium">
            <input type="checkbox" name="onSns" :id="`onSns_${sns.id}`" :value="sns.id" v-model="sns.active">
            <label :for="`onSns_${sns.id}`">{{ sns.label }}</label>
          </span>
          <input type="url" class="input mt5" v-model="sns.url" placeholder="url">
        </li>
      </ul>
    </div>
    <div v-else class="message">{{locale.menu_info_select}}</div>
  </div>
</template>

<script>
import SetLink from '@/components/Util/SetLink'

export default {
  name: 'SetUnit',
  props: [
    'locale',
    'mode',
    'link',
    'snsList'
  ],
  components: {
    SetLink
  }
}
</script>

<style lang="scss" scoped>
.message {
  img {
    position: relative;
    width: 16px;
    margin: 0 0.2em;
    opacity: 0.7;
  }
}
</style>
